// constants
import { DiscountCouponActionTypes } from './constants';
import { DiscountCoupon as DiscountCouponData } from 'src/types/discountCoupon';

export type DiscountCouponActionType = {
    type:
        | DiscountCouponActionTypes.API_RESPONSE_SUCCESS
        | DiscountCouponActionTypes.API_RESPONSE_ERROR
        | DiscountCouponActionTypes.ADD_DISCOUNT_COUPON
        | DiscountCouponActionTypes.EDIT_DISCOUNT_COUPON
        | DiscountCouponActionTypes.GET_DISCOUNT_COUPON
        | DiscountCouponActionTypes.GET_DISCOUNT_COUPONS
        | DiscountCouponActionTypes.RESET
        | DiscountCouponActionTypes.RESET_SUCCESS
        | DiscountCouponActionTypes.RESET_ERROR;
    payload: {} | string;
};

// common success
export const discountCouponApiResponseSuccess = (
    actionType: string,
    data: DiscountCouponData | {},
    message: string,
    code: number,
    error: string | boolean,
    success: boolean
): DiscountCouponActionType => ({
    type: DiscountCouponActionTypes.API_RESPONSE_SUCCESS,
    payload: { actionType, data, message, code, error, success },
});
// common error
export const discountCouponApiResponseError = (
    actionType: string,
    data: DiscountCouponData | {},
    message: string,
    code: number,
    error: string | boolean,
    success: boolean
): DiscountCouponActionType => ({
    type: DiscountCouponActionTypes.API_RESPONSE_ERROR,
    payload: { actionType, data, message, code, error, success },
});

export const addDiscountCoupon = (params: any): DiscountCouponActionType => ({
    type: DiscountCouponActionTypes.ADD_DISCOUNT_COUPON,
    payload: params,
});

export const editDiscountCoupon = (params: any): DiscountCouponActionType => ({
    type: DiscountCouponActionTypes.EDIT_DISCOUNT_COUPON,
    payload: params,
});

export const GetDiscountCoupons = (params: any): DiscountCouponActionType => ({
    type: DiscountCouponActionTypes.GET_DISCOUNT_COUPONS,
    payload: params,
});

export const GetDiscountCoupon = (params: any): DiscountCouponActionType => ({
    type: DiscountCouponActionTypes.GET_DISCOUNT_COUPON,
    payload: params,
});

export const resetDiscountCoupon = (): DiscountCouponActionType => ({
    type: DiscountCouponActionTypes.RESET,
    payload: {},
});

export const resetDiscountCouponSuccess = (): DiscountCouponActionType => ({
    type: DiscountCouponActionTypes.RESET_SUCCESS,
    payload: {},
});
export const resetDiscountCouponError = (): DiscountCouponActionType => ({
    type: DiscountCouponActionTypes.RESET_ERROR,
    payload: {},
});
